/** Path of the identity providers list page. */
export const IDENTITY_PROVIDERS_PATH =
  "/settings/access-control/identity-providers";

/**
 * Tooltip copy for the add affordances — the list page's action bar and the add
 * form's save action — which are disabled without system edit permission.
 */
export const ADD_PROVIDER_PERMISSION_MESSAGE =
  "You need system edit permission to add an identity provider";

/**
 * Path of a single provider's details page. Providers are addressed by their
 * Cognito provider name, which is unique and immutable but caller-supplied, so
 * it is encoded rather than interpolated raw.
 */
export function identityProviderPath(name: string) {
  return `${IDENTITY_PROVIDERS_PATH}/${encodeURIComponent(name)}`;
}

/** Path of a single provider's edit form. */
export function identityProviderEditPath(name: string) {
  return `${identityProviderPath(name)}/edit`;
}

/**
 * Tooltip copy for the edit affordances — the details page's edit action and
 * the edit form's save action — which are disabled without system edit
 * permission.
 */
export const EDIT_PROVIDER_PERMISSION_MESSAGE =
  "You need system edit permission to edit an identity provider";

/**
 * Tooltip copy for the details page's remove action, which is disabled without
 * system edit permission.
 */
export const REMOVE_PROVIDER_PERMISSION_MESSAGE =
  "You need system edit permission to remove an identity provider";
